import { Component, Input, Inject, OnChanges, SimpleChanges, DOCUMENT } from '@angular/core';


@Component({
  selector: 'app-schema-jsonld',
  standalone: true,
  template: ``,
})
export class SchemaJsonLdComponent implements OnChanges {
  @Input() id = 'app-jsonld';            // unique per page/type if you want multiple
  @Input({ required: true }) schema!: any;

  constructor(@Inject(DOCUMENT) private doc: Document) { }

  ngOnChanges(_: SimpleChanges) {
    const existing = this.doc.getElementById(this.id) as HTMLScriptElement | null;
    const json = JSON.stringify(this.schema, null, 0);

    if (existing) {
      // Update in-place (client navigations)
      existing.textContent = json;
      return;
    }
    // Create script (works on SSR + client)
    const script = this.doc.createElement('script');
    script.type = 'application/ld+json';
    script.id = this.id;
    script.text = json;
    this.doc.head.appendChild(script);
  }
}
